import {
  IProjectSpaceTypeCategory,
  IProjectSpaceTypeSubcategory,
} from 'spw-redux/modules/projects/types';

export type SpaceTypeColor = {
  id: number;
  color: string;
  gradientColorIndex: number;
};

export interface ISpaceTypesState {
  isFetchingSpaceTypes: boolean;
  clientFacingNamesAreVisible: boolean;
  spaceTypes: IProjectSpaceType[];
  currentSpaceTypeColors?: { [index: string]: SpaceTypeColor };
}

export type Category =
  | 'meetingSpaces'
  | 'individualWorkspaces'
  | 'amenitySpaces'
  | 'supportSpaces'
  | 'customCategory';

export type Subcategory =
  | 'privateOffices'
  | 'workstations'
  | 'customSubcategory';

export interface ISpaceTypeCategory {
  id?: number;
  name?: string;
  category: Category | Subcategory;
  spaceTypes?: ISpaceType[];
}

export const isProjectSpaceTypeSubcategory = (
  category: any
): category is IProjectSpaceTypeSubcategory => {
  return !!category?.parentId;
};

export interface ISpaceTypeSubcategory
  extends Omit<ISpaceTypeCategory, 'icon' | 'category' | 'spaceTypes'> {
  category: Subcategory;
}

export interface ISpaceType {
  id?: number;
  name: string;
  spaceType?: string /* TODO: Rename the spaceType field to avoid confusion */;
  spaceTypeCategory?: ISpaceTypeCategory;
  priority?: number;
  icon?: string;
  parent?: ISpaceType | null;
  children?: ISpaceType[];
  isCustom?: boolean;
}

export interface IProjectSpaceType {
  id: number;
  spaceType: ISpaceType;
  category: IProjectSpaceTypeCategory | IProjectSpaceTypeSubcategory;
  previousId?: number;
  projectId?: number | null;
  parent?: ISpaceType | null;
  icon: string | null;
  clientFacingName?: string;
  color?: string;
  gradientColorIndex?: number;
  isCustom?: boolean;
}
